(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["homepage-art-categories"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('ao-category-carousel')) {
  customElements.define('ao-category-carousel', class extends HTMLElement {
    connectedCallback() {
      this.initFrame = requestAnimationFrame(() => this.initialize());
    }

    initialize() {
      if (this.controller) return;
      this.list = this.querySelector('[data-category-list]');
      this.controls = this.querySelector('[data-category-controls]');
      this.previous = this.querySelector('[data-category-previous]');
      this.next = this.querySelector('[data-category-next]');
      if (!this.list || !this.controls || !this.previous || !this.next) return;

      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const queueUpdate = () => {
        cancelAnimationFrame(this.updateFrame);
        this.updateFrame = requestAnimationFrame(() => this.updateControls());
      };

      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.list.addEventListener('scroll', queueUpdate, { ...options, passive: true });
      this.list.addEventListener('keydown', (event) => {
        if (event.target !== this.list || this.controls.hidden) return;
        const rtl = getComputedStyle(this.list).direction === 'rtl';
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault();
          this.move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          const max = this.list.scrollWidth - this.list.clientWidth;
          this.list.scrollTo({ left: event.key === 'Home' ? 0 : max * (rtl ? -1 : 1), behavior: this.scrollBehavior() });
        }
      }, options);

      this.observer = new ResizeObserver(queueUpdate);
      this.observer.observe(this.list);
      if (this.list.firstElementChild) this.observer.observe(this.list.firstElementChild);
      this.updateControls();
    }

    scrollBehavior() {
      return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    }

    move(direction) {
      const first = this.list.firstElementChild;
      if (!first) return;
      const style = getComputedStyle(this.list);
      const step = first.getBoundingClientRect().width + (parseFloat(style.columnGap) || 0);
      this.list.scrollBy({ left: direction * step * (style.direction === 'rtl' ? -1 : 1), behavior: this.scrollBehavior() });
    }

    updateControls() {
      const max = this.list.scrollWidth - this.list.clientWidth;
      const overflow = max > 2;
      const position = Math.min(max, Math.max(0, Math.abs(this.list.scrollLeft)));
      this.controls.hidden = !overflow;
      if (overflow) this.list.setAttribute('tabindex', '0');
      else this.list.removeAttribute('tabindex');
      this.previous.disabled = position <= 2;
      this.next.disabled = max - position <= 2;
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.initFrame);
      cancelAnimationFrame(this.updateFrame);
      this.controller?.abort();
      this.controller = null;
      this.observer?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-product-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('atelier-video-gallery')) {
    customElements.define('atelier-video-gallery', class extends HTMLElement {
      connectedCallback() {
        requestAnimationFrame(() => this.initialize());
      }
      initialize() {
        if (this.abort) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.track = this.querySelector('.av-track');
        this.cards = [...this.querySelectorAll('.av-card')];
        this.videos = [...this.querySelectorAll('video')];
        this.dots = [...this.querySelectorAll('.av-dot')];
        this.reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (!this.track || !this.cards.length) return;
        this.videos.forEach(video => {
          const media = video.closest('.av-media');
          const play = media.querySelector('.av-play');
          const error = media.querySelector('.av-error');
          video.controls = false;
          play.addEventListener('click', () => {
            error.hidden = true;
            video.controls = true;
            video.play().catch(() => { error.hidden = false; });
          }, options);
          video.addEventListener('play', () => {
            this.videos.forEach(other => { if (other !== video) other.pause(); });
            media.classList.add('is-playing');
            this.stopTimer();
          }, options);
          video.addEventListener('pause', () => {
            media.classList.remove('is-playing');
            this.startTimer();
          }, options);
          video.addEventListener('ended', () => media.classList.remove('is-playing'), options);
          video.addEventListener('error', () => {
            media.classList.remove('is-playing');
            error.hidden = false;
          }, options);
        });
        this.dots.forEach(dot => dot.addEventListener('click', () => this.moveTo(Number(dot.dataset.index)), options));
        this.querySelector('.av-prev')?.addEventListener('click', () => this.step(-1), options);
        this.querySelector('.av-next')?.addEventListener('click', () => this.step(1), options);
        this.track.addEventListener('scroll', () => this.updateNavigation(), { ...options, passive:true });
        this.addEventListener('mouseenter', () => { this.hovered = true; this.stopTimer(); }, options);
        this.addEventListener('mouseleave', () => { this.hovered = false; this.startTimer(); }, options);
        this.addEventListener('focusin', () => this.stopTimer(), options);
        this.addEventListener('focusout', () => this.startTimer(), options);
        this.track.addEventListener('pointerdown', () => this.stopTimer(), options);
        this.track.addEventListener('pointerup', () => this.startTimer(), options);
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) { this.videos.forEach(video => video.pause()); this.stopTimer(); }
          else this.startTimer();
        }, options);
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.target === this) {
              this.inView = entry.isIntersecting;
              if (this.inView) this.startTimer();
              else { this.videos.forEach(video => video.pause()); this.stopTimer(); }
            } else if (!entry.isIntersecting) entry.target.querySelector('video')?.pause();
          });
        }, { threshold:0.1 });
        this.observer.observe(this);
        this.cards.forEach(card => this.observer.observe(card));
        this.resizeObserver = new ResizeObserver(() => this.updateNavigation());
        this.resizeObserver.observe(this.track);
        this.updateNavigation();
        if (this.dataset.videoAutoplay === 'true' && !this.reduceMotion && this.videos[0]) {
          this.videos[0].muted = true;
          this.videos[0].play().catch(() => {});
        }
      }
      moveTo(index) {
        const left = this.positions[Math.max(0, Math.min(index, this.positions.length - 1))];
        this.track.scrollTo({ left, behavior:this.reduceMotion ? 'instant' : 'smooth' });
      }
      step(direction) {
        const end = this.track.scrollWidth - this.track.clientWidth;
        if (direction > 0 && this.track.scrollLeft >= end - 2) this.moveTo(0);
        else this.moveTo((this.currentIndex || 0) + direction);
      }
      updateNavigation() {
        const left = this.track.getBoundingClientRect().left + 20;
        const end = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        this.positions = this.cards.map(card => Math.max(0, Math.min(end, card.getBoundingClientRect().left - left + this.track.scrollLeft)))
          .filter((position, index, positions) => index === 0 || Math.abs(position - positions[index - 1]) > 2);
        this.currentIndex = this.positions.reduce((best, position, index) =>
          Math.abs(position - this.track.scrollLeft) < Math.abs(this.positions[best] - this.track.scrollLeft) ? index : best, 0);
        this.dots.forEach((dot, index) => {
          dot.hidden = index >= this.positions.length;
          if (index === this.currentIndex) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        const previous = this.querySelector('.av-prev');
        if (previous) previous.disabled = this.track.scrollLeft <= 2;
      }
      startTimer() {
        this.stopTimer();
        if (this.dataset.carouselAutoplay !== 'true' || this.reduceMotion || !this.inView || this.hovered || document.hidden || this.contains(document.activeElement) || this.videos.some(video => !video.paused)) return;
        this.timer = setInterval(() => this.step(1), Number(this.dataset.delay) || 8000);
      }
      stopTimer() { clearInterval(this.timer); }
      disconnectedCallback() {
        this.stopTimer();
        this.abort?.abort();
        this.abort = null;
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
        this.videos?.forEach(video => video.pause());
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
